import {
  getAllExpenses,
  createExpense,
  createAllExpenses,
  updateExpense,
  deleteExpense,
} from '@/services/expense';

const state = {
  expenses: [],
  processed: false,
};

const getters = {
  getExpenses(state) {
    return state.expenses;
  },
  expenseProcessed(state) {
    return state.processed;
  },
};

const actions = {
  fetchExpenses({ commit }, params) {
    commit('SET_PROCESSING');
    return new Promise((resolve, reject) => {
      getAllExpenses(params)
        .then((response) => {
          commit('SET_EXPENSES', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createExpense({ commit }, expense) {
    return new Promise((resolve, reject) => {
      createExpense(expense)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createAllExpenses({ commit }, expenses) {
    return new Promise((resolve, reject) => {
      createAllExpenses(expenses)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateExpense({ commit }, expense) {
    return new Promise((resolve, reject) => {
      updateExpense(expense)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteExpense({ commit }, id) {
    return new Promise((resolve, reject) => {
      deleteExpense(id)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  SET_EXPENSES(state, data) {
    state.expenses = data;
    state.processed = true;
  },
  SET_PROCESSING(state) {
    state.processed = false;
  },
  SET_PROCESSED(state) {
    state.processed = true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
